// extracted by mini-css-extract-plugin
export default {"content":"logout_content__a393Q","title":"logout_title__sh4Dw"};